var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queue-avatar"},[(!_vm.check)?_c('img',{attrs:{"src":_vm.avatar}}):_vm._e(),(_vm.check)?_c('icon-check'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }